module.exports = __webpack_public_path__ + "static/media/stockspot.eb3c4db3.png";